import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useNetworkStatus } from "./hooks/useNetworkStatus";
import React, { useEffect, useRef, useState, Suspense, lazy } from "react";
import { toast, Toaster } from "react-hot-toast";
import NotFound from "./pages/404/NotFound";
import AccessDenied from "./pages/access-denied/AccessDenied";
import Call from "./components/lib/Call";
import LogIn from "./pages/Login/LogIn";
import IsLogin from "./components/lib/IsLogin";
import LoadingScreen from "./components/common/LoadingScreen";
const Home = lazy(() => import("./pages/home/Home"));
const CallLog = lazy(() => import("./pages/CallLog/CallLog"));
const OrderHistory = lazy(() => import("./pages/order-history/order-history"));
const TakeOrder = lazy(() => import("./pages/TakeOrder/TakeOrder"));
// import Overview from "./pages/backoffice/Overview"
// import Staff from "./pages/backoffice/staff/Staff"
// import AddStaff from "./pages/backoffice/staff/AddStaff"
// import EditStaff from "./pages/backoffice/staff/EditStaff"
// import AllStaff from "./pages/backoffice/staff/AllStaff"

const Floor = lazy(() => import("./pages/liveTable/Floor"));
import FloorDetails from "./pages/liveTable/FloorDetails";
const LiveTable = lazy(() => import("./pages/liveTable/LiveTable"));
import EditLiveTable from "./pages/liveTable/EditLiveTable";
import MergeTable from "./pages/liveTable/MergeTable";
import SeparateTable from "./pages/liveTable/SeparateTable";

const TableSideOrderingLayout = lazy(() => import("./pages/tableSideOrdering/TableSideOrderingLayout"));
const CustomerSelfOrderSetup = lazy(() => import("./pages/tableSideOrdering/CustomerSelfOrderSetup"));
const CustomerSelfOrderKiosk = lazy(() => import("./pages/tableSideOrdering/CustomerSelfOrderKiosk"));
const QrCodeOrderPlaceholder = lazy(() => import("./pages/tableSideOrdering/QrCodeOrderPlaceholder"));

const GiftCard = lazy(() => import("./pages/loyalty/giftCard/GiftCard"));
const Loyalty = lazy(() => import("./pages/loyalty/Loyalty"));
const LoyaltyOverview = lazy(() => import("./pages/loyalty/LoyaltyOverview"));
import AddGiftCard from "./pages/loyalty/giftCard/AddGiftCard";
const Voucher = lazy(() => import("./pages/loyalty/voucher/Voucher"));
const AddVoucher = lazy(() => import("./pages/loyalty/voucher/AddVoucher"));
const C2CVoucher = lazy(() => import("./pages/loyalty/c2cVoucher/C2CVoucher"));
const AddC2CVoucher = lazy(
  () => import("./pages/loyalty/c2cVoucher/AddC2CVoucher"),
);
import Templetas from "./pages/loyalty/templets/templetes";
import PointBasedOffer from "./pages/loyalty/pointBased/PointBasedOffer";
import AddPointBasedOffer from "./pages/loyalty/pointBased/AddPointBasedOffer";
import Concession from "./pages/loyalty/concession/Concession";
import BuyGetItemOffer from "./pages/loyalty/offers/buyGetItem/BuyGetItemOffer";
import AddBuyGetItemOffer from "./pages/loyalty/offers/buyGetItem/AddBuyGetItemOffer";
import BuyGetDiscountOffer from "./pages/loyalty/offers/buyGetDiscount/BuyGetDiscountOffer";
import AddBuyGetDiscountOffer from "./pages/loyalty/offers/buyGetDiscount/AddBuyGetDiscountOffer";
import SpendGetItemOffer from "./pages/loyalty/offers/spendGetItem/SpendGetItemOffer";
import AddSpendGetItemOffer from "./pages/loyalty/offers/spendGetItem/AddSpendGetItemOffer";
import SpendGetDiscountOffer from "./pages/loyalty/offers/spendGetDiscount/SpendGetDiscountOffer";
import AddSpendGetDiscountOffer from "./pages/loyalty/offers/spendGetDiscount/AddSpendGetDiscountOffer";
import OnlineOrderDiscountOffer from "./pages/loyalty/offers/onlineOrderDiscount/OnlineOrderDiscountOffer";
import AddOnlineOrderDiscountOffer from "./pages/loyalty/offers/onlineOrderDiscount/AddOnlineOrderDiscountOffer";

// customer
import Customer from "./pages/backoffice/customer/customer";
import CustomerDetails from "./pages/backoffice/customer/customer-details";

// all staff
import AllStaff from "./pages/backoffice/staffManagement/allstaf/AllStaff";
import AddNewStaff from "./pages/backoffice/staffManagement/allstaf/add-new-staff";
import UpdateStaff from "./pages/backoffice/staffManagement/allstaf/update-staff";
import StaffProfile from "./pages/backoffice/staffManagement/allstaf/staff-profile";
import UserProfile from "./pages/backoffice/user-profile";
// role access
import RoleAccess from "./pages/backoffice/staffManagement/allstaf/role-access/role-acces";
// payroll
import Payroll from "./pages/backoffice/staffManagement/allstaf/payroll/payroll";
import PayrollDetails from "./pages/backoffice/staffManagement/allstaf/payroll/pay-details";
// shift Schedule
import ShiftSchedule from "./pages/backoffice/staffManagement/allstaf/shift-schedule/shift-schedule";
// staff report
import StaffReports from "./pages/backoffice/staffManagement/allstaf/staff-report/staff-reports";
import SingleStaffDetails from "./pages/backoffice/staffManagement/allstaf/staff-report/single-staff-details";
// leave settings
import LeavesSettings from "./pages/backoffice/staffManagement/allstaf/leaves-settings/leaves-settings";
import Holidays from "./pages/backoffice/staffManagement/allstaf/holidays/holidays";
// time sheet
import TimeSheet from "./pages/backoffice/staffManagement/allstaf/time-sheet/time-sheet";
import TimeSheetReport from "./pages/backoffice/staffManagement/allstaf/time-sheet/time-sheet-report";
import TimeSheetSchedule from "./pages/backoffice/staffManagement/allstaf/time-sheet/time-sheet-schedule";
import AllNotification from "./pages/backoffice/notification/all-notification";
import AllOnlineNotification from "./pages/backoffice/notification/all-online-notification";
import SupportHelp from "./pages/backoffice/staffManagement/support-help";
// menu management
import Drinks from "./pages/backoffice/menu-management/drink/drinks";
import CreateDrinks from "./pages/backoffice/menu-management/drink/create-drinks";
// pizz management
import Pizza from "./pages/backoffice/menu-management/pizza/pizza";
import CreatePizza from "./pages/backoffice/menu-management/pizza/create-pizza";
// tea and coffee
import TeaCoffee from "./pages/backoffice/menu-management/tea&coffe/tea-coffee";
import CreateTeaCoffe from "./pages/backoffice/menu-management/tea&coffe/create-tea-coffee";
// burger
import Burger from "./pages/backoffice/menu-management/burger/burger";
import CreateBurger from "./pages/backoffice/menu-management/burger/create-burger";
// kabab
import Kabab from "./pages/backoffice/menu-management/kabab/kabab";
import CreateKabab from "./pages/backoffice/menu-management/kabab/create-kabab";
// fish and chips
import FishAndChips from "./pages/backoffice/menu-management/fish-and-chips/fishAndChips";
import CreateFishAndChips from "./pages/backoffice/menu-management/fish-and-chips/create-fish";
// combo meal
import ComboMeal from "./pages/backoffice/menu-management/combo-meal/combo-meal";
import CreateComboMeal from "./pages/backoffice/menu-management/combo-meal/create-combo-meal";
// dessert
import Dessert from "./pages/backoffice/menu-management/dessert/dessert";
import CreateDessert from "./pages/backoffice/menu-management/dessert/create-dessert";
// course
import Course from "./pages/backoffice/menu-management/course/course";
import CreateCourse from "./pages/backoffice/menu-management/course/create-course";
// mix and match
import MixAndMatch from "./pages/backoffice/menu-management/mix-and-match/mix-and-match";
import CreateMixAndMatch from "./pages/backoffice/menu-management/mix-and-match/create-mix-and-match";
// Choose Your Own
import CreateYourOwnGeneral from "./pages/backoffice/menu-management/create-your-own-general/create-your-own-general";
import CreateCreateYourOwnGeneral from "./pages/backoffice/menu-management/create-your-own-general/create-create-your-own-general";

// standard foods
import StandardFood from "./pages/backoffice/menu-management/standard-foods/standard-foods";
import CreateStandardFoods from "./pages/backoffice/menu-management/standard-foods/create-standard-food";
// essentail drink
import EssentialDrink from "./pages/backoffice/menu-management/manage-essential/essential-drink/essential-drink";
import EssentialAddNewCtg from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-ctg/essential-add-new-cgt";
import EssentialUpdateCtg from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-ctg/essential-update-ctg";
import EssentialAddNewBrand from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-brand/essential-add-new-brand";
import EssentialUpdateBrand from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-brand/essential-update-brand";
import EssentialAddNewIngredients from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-ingredients/essential-add-new-Ingredients";
import EssentialUpdateIngredients from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-ingredients/essential-update-Ingredients";
import EssentialAddNewAddons from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-addons/essential-add-new-addons";
import EssentialUpdateAddons from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-addons/essential-update-addons";
import EssentialAddNewAllergen from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-allergen/essential-add-new-allergen";
import EssentialUpdateAllergen from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-allergen/essential-update-allergen";
import AddNewModifiers from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-modifiers/essential-add-new-modifiers";
import UpdateModifiers from "./pages/backoffice/menu-management/manage-essential/essential-drink/essentail-modifiers/essential-update-modifiers";
// essentail tea and coffee
import EssentialTeaCoffee from "./pages/backoffice/menu-management/manage-essential/essential-tea-coffee/essential-tea-coffee";
// essentail burger
import EssentialBurger from "./pages/backoffice/menu-management/manage-essential/essential-burger/essential-burger";
import EssentialBurgerSaladAdd from "./pages/backoffice/menu-management/manage-essential/essential-burger/burger-salad/essential-burger-salad";
import EssentialBurgerSaladUpdate from "./pages/backoffice/menu-management/manage-essential/essential-burger/burger-salad/essential-burger-salad-update";
import EssentialBurgerSauceAdd from "./pages/backoffice/menu-management/manage-essential/essential-burger/burger-sauce/essential-burger-sauce";
import EssentialBurgerSauceUpdate from "./pages/backoffice/menu-management/manage-essential/essential-burger/burger-sauce/essential-burger-sauce-update";

// essentail kebab
import EssentialKebab from "./pages/backoffice/menu-management/manage-essential/essential-kebab/essential-kebab";

// essentail fish-chips
import EssentialFishChips from "./pages/backoffice/menu-management/manage-essential/essential-fish-chips/essentail-fish-chips";
// essentail standardFoods
import EssentialStandardFoods from "./pages/backoffice/menu-management/manage-essential/essential-standard-foods/essential-standard-foods";
// essentail dessert
import EssentialDessert from "./pages/backoffice/menu-management/manage-essential/essential-dessert/essential-dessert";
// essentail special menu
import EssentialSpecialMenu from "./pages/backoffice/menu-management/manage-essential/special-menu/special-menu";

// essentail pizza
import EssentialPizza from "./pages/backoffice/menu-management/manage-essential/essential-pizza/essential-pizza";
import EssentialPizzaAddNewBase from "./pages/backoffice/menu-management/manage-essential/essential-pizza/pizza-base/essential-pizza-add-new-base";
import EssentialPizzaUpdateBase from "./pages/backoffice/menu-management/manage-essential/essential-pizza/pizza-base/essential-pizza-update-base";
import EssentialPizzaAddNewCrust from "./pages/backoffice/menu-management/manage-essential/essential-pizza/pizza-crust/essential-pizza-add-new-crust";
import EssentialPizzaUpdateCrust from "./pages/backoffice/menu-management/manage-essential/essential-pizza/pizza-crust/essential-pizza-update-crust";
import EssentialPizzaAddNewTroppings from "./pages/backoffice/menu-management/manage-essential/essential-pizza/pizza-troppings/essential-pizza-add-new-troppings";
import EssentialPizzaUpdateTroppings from "./pages/backoffice/menu-management/manage-essential/essential-pizza/pizza-troppings/essential-pizza-update-troppings";
// essentile combo meal
import EssentialComboMeal from "./pages/backoffice/menu-management/manage-essential/essential-combo-meal/essentail-combo-meal";
// special menu
import SpecialMenu from "./pages/backoffice/menu-management/special-menu/special-menu";
import CreateDishOfDay from "./pages/backoffice/menu-management/special-menu/dish-of-day/create-dish-of-day";
import SundayRoast from "./pages/backoffice/menu-management/special-menu/sunday-roast/sunday-roast";
import CreateSundayRoast from "./pages/backoffice/menu-management/special-menu/sunday-roast/create-sunday-roast";
import BanquetNight from "./pages/backoffice/menu-management/special-menu/banquet-night/banquet-night";
import CreateBanquetNight from "./pages/backoffice/menu-management/special-menu/banquet-night/create-banquet-night";
import Buffet from "./pages/backoffice/menu-management/special-menu/buffet/buffet";
import CreateBuffet from "./pages/backoffice/menu-management/special-menu/buffet/create-buffet";
import Christmas from "./pages/backoffice/menu-management/special-menu/christmas/christmas";
import CreateChristmas from "./pages/backoffice/menu-management/special-menu/christmas/create-christmas";
import Party from "./pages/backoffice/menu-management/special-menu/party/party";
import CreateParty from "./pages/backoffice/menu-management/special-menu/party/create-party";

// onlline ordering
const OnlineOrdering = lazy(
  () => import("./pages/online-ordering/OnlineOrdering"),
);
const PaymentSuccess = lazy(
  () => import("./pages/payment/PaymentSuccess"),
);
const PaymentFailed = lazy(
  () => import("./pages/payment/PaymentFailed"),
);
const PaymentCancelled = lazy(
  () => import("./pages/payment/PaymentCancelled"),
);
const WebsiteOrderingAvailableItems = lazy(
  () =>
    import("./pages/online-ordering/websiteOrdering/WebsiteOrderingAvailableItems"),
);
const InvoiceStatementPage = lazy(
  () =>
    import("./pages/online-ordering/websiteOrdering/invoiceStatement/InvoiceStatementPage"),
);
const InvoiceStatementByDatePage = lazy(
  () =>
    import("./pages/online-ordering/websiteOrdering/invoiceStatement/InvoiceStatementByDatePage"),
);
const ReservationOrderSettings = lazy(
  () => import("./pages/online-ordering/Settings/reservation-order-settings"),
);

// admin routes
import AdminLogin from "./pages/admin/auth/admin-login";
import ClientDetails from "./pages/admin/quick-signup/quick-signup";
import Permission from "./components/lib/Permission";
import Redirect from "./pages/Login/Redirect";
import OrderRequest from "./pages/online-ordering/websiteOrdering/OrderRequest";
import OrderStatus from "./pages/online-ordering/websiteOrdering/OrderStatus";
import QrOrderRequest from "./pages/online-ordering/qrCodeOrdering/QrOrderRequest";
import QrOrderStatus from "./pages/online-ordering/qrCodeOrdering/QrOrderStatus";
import QrAvailableItems from "./pages/online-ordering/qrCodeOrdering/QrAvailableItems";
import QrCodeGenerate from "./pages/online-ordering/qrCodeOrdering/QrCodeGenerate";
import OnlineOrderHistory from "./pages/online-ordering/onlineOrderHistory/OnlineOrderHistory";
const WebsiteSettings = lazy(
  () => import("./pages/online-ordering/Settings/WebsiteSettings"),
);
const SoundsSettings = lazy(
  () => import("./pages/backoffice/settings/sounds-settings/sounds-settings"),
);
import Notice from "./pages/online-ordering/Settings/Notice";
import TemporaryDisable from "./pages/online-ordering/Settings/TemporaryDisable";
import OrderAcceptability from "./pages/online-ordering/Settings/OrderAcceptability";
import TillOrderAccess from "./pages/online-ordering/Settings/till-order-access";
import OnlineOrderSettings from "./pages/online-ordering/Settings/OnlineOrderSettings";
import SingleOrderRequest from "./pages/online-ordering/websiteOrdering/SingleOrderRequest";
import SingleOrderStatus from "./pages/online-ordering/websiteOrdering/SingleOrderStatus";
import SingleQrOrderRequest from "./pages/online-ordering/qrCodeOrdering/SingleQrOrderRequest";
import SingleQrOrderStatus from "./pages/online-ordering/qrCodeOrdering/SingleQrOrderStatus";
import CreateNotice from "./components/online-ordering/settings/Notice/CreateNotice";
import CreateQrCode from "./components/online-ordering/qrCodeOrdering/CreateQrCode";

// cbd
import CBD from "./pages/cbd/cbd";
import SingleCustomerDetails from "./pages/cbd/single-customer-details";

// reservation
import ReservationList from "./pages/reservation/reservation-list";
import AddReservation from "./pages/reservation/add-reservation";
import ReservationDetails from "./pages/reservation/reservation-details";
import CallingUnknown from "./pages/reservation/calling-unknown";
import AddConcession from "./pages/loyalty/concession/AddConcession";
import ReservationRequest from "./pages/reservation/reservation-request";
import ReservationRqDetails from "./pages/reservation/reservation-rq-details";

// offline
import OfflinePage from "./pages/utlity/offline-page";
// settings
import Overview from "./pages/backoffice/Overview";
import MenuOverview from "./pages/backoffice/menu-management/MenuOverview";
import TakeOrderSettings from "./pages/backoffice/settings/take-order/take-order-settings";
import DiscountManagement from "./pages/backoffice/settings/discount/discountManagement";
import AddDiscount from "./pages/backoffice/settings/discount/AddDicount";
import EditDiscount from "./pages/backoffice/settings/discount/EditDiscount";
import DeviceManagement from "./pages/backoffice/settings/device-management/device-management";
// table
import TableFloorPlan from "./pages/backoffice/TableFloorPlan";
import TablePage from "./pages/table/TablePage";
import DelevariyManagement from "./pages/backoffice/settings/delivery-management/delivery-management";
import PusherExample from "./api/lib/pusher/TablePusherExample";
import DualPusherExample from "./api/lib/pusher/DualPusherExample";
import PusherInitializer from "./api/lib/pusher/PusherInitializer";
import TablePusher from "./api/lib/pusher/TablePusher";
import ReservationPusher from "./api/lib/pusher/ReservationPusher";
import TableBookingHistory from "./pages/table/table-booking-history";
import PrinterList from "./pages/backoffice/printer-management/printerList";

// cost management
import ComplementaryReport from "./pages/backoffice/cost-management/complementary-report";
import TableReplaceItemReport from "./pages/backoffice/cost-management/table-replace-item-report";
import TakeAwayReplaceItemReport from "./pages/backoffice/cost-management/take-away-replace-item-report";
import SmsUsageHistory from "./pages/backoffice/cost-management/sms-usage-history";
import ReceiptManagement from "./pages/backoffice/settings/receipt-management/receipt-management";
import PointsRewardSettings from "./pages/backoffice/settings/points/points-reward-settings";
import TillToTillShare from "./pages/backoffice/till-to-till-share/till-to-till-share";

// dashboard module
import DashboardMain from "./pages/dashboard/DashboardMain";
import DashboardOverview from "./pages/dashboard/overview";
import RevenueReports from "./pages/dashboard/revenue-reports/revenue-reports";
import CallLogReports from "./pages/dashboard/call-log-reports/call-log-reports";
import OrderReports from "./pages/dashboard/order-reports/order-reports";
import ReservationReports from "./pages/dashboard/reservation-reports/reservation-reports";
import TableReports from "./pages/dashboard/table-reports/tabole-reports";
import LoyaltyReports from "./pages/dashboard/loyalty-reports/loyalty-reports";
import MenuReports from "./pages/dashboard/menu-reports/menu-reports";
import DashboardStaffReport from "./pages/dashboard/staff-reports/staff-reports";
import Reporting from "./pages/reporting/reporting";
import GrandReport from "./pages/reporting/grand-report";
import EndOfDayReportX from "./pages/reporting/end-of-day-report-x";
import EndOfDayReportZSummary from "./pages/reporting/end-of-day-report-z-summary";
import EndOfDayReportZDetails from "./pages/reporting/end-of-day-report-z-details";
import EndOfDayReportZServiceType from "./pages/reporting/end-of-day-report-z-service-type";
import EndOfDayReportZSale from "./pages/reporting/end-of-day-report-z-sale";
import ReportSettings from "./pages/reporting/report-settings";
import ReportingAccessGuard from "./pages/reporting/components/auth/reporting-access-guard";
import { clearReportingAccessSession } from "./pages/reporting/components/auth/reporting-otp-storage";
import GeneralQRCode from "./pages/online-ordering/qr-code/general-qr-code";
import SmartQRCodeOrder from "./pages/online-ordering/qr-code/smart-qr-code-order";
import AddSmartQRCodeOrder from "./pages/online-ordering/qr-code/add-smart-qr-code-order";
import EditSmartQRCodeOrder from "./pages/online-ordering/qr-code/edit-smart-qr-code-order";


function App() {
  const isOnline = useNetworkStatus();
  const [showOffline, setShowOffline] = useState(!isOnline);
  const location = useLocation();

  // Destroy reporting access verification session whenever user leaves reporting module
  useEffect(() => {
    if (!location.pathname.startsWith("/reporting")) {
      clearReportingAccessSession();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isOnline) {
      setShowOffline(false);
    } else {
      setShowOffline(true);
    }
  }, [isOnline]);

  const handleRetry = () => {
    if (navigator.onLine) {
      setShowOffline(false);
    } else {
      toast.error("Still offline, check your connection");
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  if (showOffline) {
    return <OfflinePage onRetry={handleRetry} />;
  }

  return (
    <>
      <Toaster />
      <Call />
      <PusherInitializer />
      <TablePusher />
      <ReservationPusher />
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route path="/" element={<Redirect />} />
          <Route path="/:restaurant_system_id" element={<LogIn />} />
          <Route path="/auth/admin/login" element={<AdminLogin />} />

          <Route path="/pusher" element={<PusherExample />} />
          <Route path="/pusher2" element={<DualPusherExample />} />

          <Route path="/" element={<IsLogin />}>
            <Route path="/home" element={<Home />} />
            <Route path="/access-denied" element={<AccessDenied />} />

            <Route path="/" element={<Permission keyName={"call_log"} />}>
              <Route path="/call-log" element={<CallLog />} />
            </Route>
            <Route path="/" element={<Permission keyName={"orders_history"} />}>
              <Route path="/order-history" element={<OrderHistory />} />
            </Route>

            {/* <Route path="/" element={<IsLogin />}> */}
            {/* <Route path="/home" element={<Home />} />
          <Route path="/call-log" element={<CallLog />} /> */}
            <Route path="/" element={<Permission keyName={"take_orders.take_order"} />}>
              <Route path="/take-order" element={<TakeOrder />} />
            </Route>

            <Route element={<ReportingAccessGuard />}>
              <Route path="/" element={<Permission keyName={"reporting"} />}>
                <Route path="/reporting" element={<Reporting />} />
              </Route>
              <Route path="/" element={<Permission keyName={"reporting.reporting.view_grand_report"} />}>
                <Route path="/reporting/grand-report" element={<GrandReport />} />
              </Route>
              <Route path="/" element={<Permission keyName={"reporting.reporting.end_of_day_report_x_view"} />}>
                <Route path="/reporting/end-of-day-x" element={<EndOfDayReportX />} />
              </Route>
              <Route path="/" element={<Permission keyName={"reporting.reporting.view_end_of_day"} />}>
                <Route
                  path="/reporting/end-of-day-z-summary"
                  element={<EndOfDayReportZSummary />}
                />
              </Route>
              <Route path="/" element={<Permission keyName={"reporting.reporting.view_end_of_day_report_details"} />}>
                <Route
                  path="/reporting/end-of-day-z-details"
                  element={<EndOfDayReportZDetails />}
                />
              </Route>
              <Route path="/" element={<Permission keyName={"reporting.reporting.end_of_day_report_z"} />}>
                <Route
                  path="/reporting/end-of-day-z-service-type"
                  element={<EndOfDayReportZServiceType />}
                />
              </Route>
              <Route path="/" element={<Permission keyName={"reporting.reporting.eod_sales_report_view"} />}>
                <Route
                  path="/reporting/end-of-day-z-sale"
                  element={<EndOfDayReportZSale />}
                />
              </Route>
              <Route path="/reporting/settings" element={<ReportSettings />} />
            </Route>

            <Route path="/floor" element={<Floor />} />
            <Route path="/floor/:id" element={<FloorDetails />} />

            <Route path="/" element={<Permission keyName={"table"} />}>
              <Route path="/table" element={<TablePage />} />
            </Route>

            <Route
              path="/table-history/booking-details/:id"
              element={<TableBookingHistory />}
            />

            <Route path="/live-table/:id" element={<LiveTable />} />
            <Route path="/edit-live-table/:id" element={<EditLiveTable />} />
            <Route path="/merge-live-table/:id" element={<MergeTable />} />
            <Route
              path="/separate-live-table/:id"
              element={<SeparateTable />}
            />

            {/* Table Side Self Ordering */}
            <Route
              path="/table-side-ordering"
              element={<Navigate to="/table-side-ordering/customer-self-order" replace />}
            />
            <Route path="/table-side-ordering" element={<TableSideOrderingLayout />}>
              <Route path="customer-self-order" element={<CustomerSelfOrderSetup />} />
              <Route path="qr-code-order" element={<QrCodeOrderPlaceholder />} />
            </Route>
            <Route
              path="/table-side-ordering/customer-self-order/kiosk"
              element={<CustomerSelfOrderKiosk />}
            />

            <Route path="/" element={<Permission keyName={"loyalty_offer"} />}>
              <Route path="/loyalty" element={<Loyalty />} />
              <Route path="/loyalty/overview" element={<LoyaltyOverview />} />
            </Route>

            <Route path="/" element={<Permission keyName={"loyalty_offer.gift_card.view_gift_card"} />}>
              <Route path="/loyalty/gift-card" element={<GiftCard />} />
            </Route>
            <Route path="/" element={<Permission keyName={"loyalty_offer.gift_card.create_gift_card"} />}>
              <Route path="/loyalty/gift-card/:type" element={<AddGiftCard />} />
            </Route>

            <Route path="/" element={<Permission keyName={"loyalty_offer.voucher.voucher_view"} />}>
              <Route path="/loyalty/voucher" element={<Voucher />} />
            </Route>
            <Route path="/" element={<Permission keyName={"loyalty_offer.voucher.create_voucher"} />}>
              <Route path="/loyalty/voucher/:type" element={<AddVoucher />} />
            </Route>

            <Route path="/" element={<Permission keyName={"loyalty_offer.c2c_gift_card.c2c_card_view"} />}>
              <Route path="/loyalty/c2c-voucher" element={<C2CVoucher />} />
            </Route>
            <Route path="/" element={<Permission keyName={"loyalty_offer.c2c_gift_card.create_c2c"} />}>
              <Route path="/loyalty/c2c-voucher/:type" element={<AddC2CVoucher />} />
            </Route>

            <Route path="/loyalty/concession" element={<Concession />} />
            <Route
              path="/loyalty/concession/:type"
              element={<AddConcession />}
            />

            <Route path="/" element={<Permission keyName={"loyalty_offer.point_based_offer.view_point_offer"} />}>
              <Route path="/loyalty/point-based" element={<PointBasedOffer />} />
            </Route>

            <Route path="/" element={<Permission keyName={"loyalty_offer.point_based_offer.create_point_offer"} />}>
              <Route
                path="/loyalty/point-based/:type"
                element={<AddPointBasedOffer />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"loyalty_offer.template"} />}>
              <Route path="/loyalty/template" element={<Templetas />} />
            </Route>

            {/* Offers Module */}
            <Route
              path="/"
              element={
                <Permission
                  keyName={[
                    "loyalty_offer.get_item_offer.offer_list",
                    "loyalty_offer.get_item_offer",
                  ]}
                />
              }
            >
              <Route path="/offer/buy-get-item" element={<BuyGetItemOffer />} />
            </Route>
            <Route
              path="/"
              element={
                <Permission
                  keyName={[
                    "loyalty_offer.get_item_offer.create_offer",
                    "loyalty_offer.get_item_offer.edit_offer",
                  ]}
                />
              }
            >
              <Route
                path="/offer/buy-get-item/:type"
                element={<AddBuyGetItemOffer />}
              />
            </Route>
            <Route
              path="/"
              element={
                <Permission
                  keyName={"loyalty_offer.get_discount_offer"}
                />
              }
            >
              <Route
                path="/offer/buy-get-discount"
                element={<BuyGetDiscountOffer />}
              />
            </Route>
            <Route
              path="/"
              element={
                <Permission
                  keyName={[
                    "loyalty_offer.get_discount_offer.create_offer",
                    "loyalty_offer.get_discount_offer.edit_offer",
                  ]}
                />
              }
            >
              <Route
                path="/offer/buy-get-discount/:type"
                element={<AddBuyGetDiscountOffer />}
              />
            </Route>
            <Route
              path="/"
              element={
                <Permission
                  keyName={[
                    "loyalty_offer.spend_item_offer.offer_list",
                    "loyalty_offer.spend_item_offer",
                  ]}
                />
              }
            >
              <Route
                path="/offer/spend-over-get-item"
                element={<SpendGetItemOffer />}
              />
            </Route>
            <Route
              path="/"
              element={
                <Permission
                  keyName={[
                    "loyalty_offer.spend_item_offer.create_offer",
                    "loyalty_offer.spend_item_offer.edit_offer",
                  ]}
                />
              }
            >
              <Route
                path="/offer/spend-over-get-item/:type"
                element={<AddSpendGetItemOffer />}
              />
            </Route>
            <Route
              path="/"
              element={
                <Permission
                  keyName={"loyalty_offer.spend_discount_offer"}
                />
              }
            >
              <Route
                path="/offer/spend-get-discount"
                element={<SpendGetDiscountOffer />}
              />
            </Route>
            <Route
              path="/"
              element={
                <Permission
                  keyName={[
                    "loyalty_offer.spend_discount_offer.create_offer",
                    "loyalty_offer.spend_discount_offer.edit_offer",
                  ]}
                />
              }
            >
              <Route
                path="/offer/spend-get-discount/:type"
                element={<AddSpendGetDiscountOffer />}
              />
            </Route>
            <Route
              path="/"
              element={
                <Permission
                  keyName={"loyalty_offer.order_online_discount_offer"}
                />
              }
            >
              <Route
                path="/offer/online-order-get-discount"
                element={<OnlineOrderDiscountOffer />}
              />
            </Route>
            <Route
              path="/"
              element={
                <Permission
                  keyName={[
                    "loyalty_offer.order_online_discount_offer.create_offer",
                    "loyalty_offer.order_online_discount_offer.edit_offer",
                  ]}
                />
              }
            >
              <Route
                path="/offer/online-order-get-discount/:type"
                element={<AddOnlineOrderDiscountOffer />}
              />
            </Route>

            {/* Cost Management */}
            <Route path="/" element={<Permission keyName={"back_office.cost_management.complementary_report"} />}>
              <Route
                path="/backoffice/cost-management/complementary-report"
                element={<ComplementaryReport />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.cost_management.table_replace_item_report"} />}>
              <Route
                path="/backoffice/cost-management/table-replace-item-report"
                element={<TableReplaceItemReport />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.cost_management.take_away_replace_item_report"} />}>
              <Route
                path="/backoffice/cost-management/take-away-replace-item-report"
                element={<TakeAwayReplaceItemReport />}
              />
            </Route>
            <Route path="/" >
              <Route
                path="/backoffice/cost-management/sms-usage-history"
                element={<SmsUsageHistory />}
              />
    
            </Route>

            {/* Admin Backoffice */}
            <Route path="/admin/quick-signup" element={<ClientDetails />} />
            <Route path="/" element={<Permission keyName={"back_office.settings.floor_plan"} />}>
              <Route
                path="/backoffice/table-floor-plan"
                element={<TableFloorPlan />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.settings.printer_management"} />}>
              <Route
                path="/backoffice/printer-management"
                element={<PrinterList />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.settings.receipt_management"} />}>
              <Route
                path="/backoffice/receipt-management"
                element={<ReceiptManagement />}
              />
            </Route>

            <Route path="/backoffice/my-account" element={<UserProfile />} />

            <Route path="/backoffice/overview" element={<Overview />} />
            <Route path="/" element={<Permission keyName={"back_office.menu_management.overview"} />}>
              <Route path="/backoffice/menu/overview" element={<MenuOverview />} />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.settings.general_settings"} />}>
              <Route
                path="/backoffice/settings/sounds-settings"
                element={<SoundsSettings />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.settings.take_order_settings"} />}>
              <Route
                path="/backoffice/settings/take-order-settings"
                element={<TakeOrderSettings />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.settings.discount_management"} />}>
              <Route
                path="/backoffice/settings/discount"
                element={<DiscountManagement />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.settings.device_management"} />}>
              <Route
                path="/backoffice/settings/device-management"
                element={<DeviceManagement />}
              />
            </Route>

            <Route
              path="/backoffice/settings/discount/add"
              element={<AddDiscount />}
            />
            <Route
              path="/backoffice/settings/discount/edit/:id"
              element={<EditDiscount />}
            />
            <Route
              path="/backoffice/settings/delivery-management"
              element={<DelevariyManagement />}
            />
            <Route path="/" element={<Permission keyName={"back_office.settings.point_reward_settings"} />}>
              <Route
                path="/backoffice/settings/points-reward-settings"
                element={<PointsRewardSettings />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.till_to_till_share.till_to_till_list"} />}>
              <Route
                path="/backoffice/till-to-till-share"
                element={<TillToTillShare />}
              />
            </Route>


            {/* all staff */}
            <Route path="/" element={<Permission keyName={"back_office.staff_management.staff_list"} />}>
              <Route
                path="/backoffice/staff-management/staff/all"
                element={<AllStaff />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.staff_management.add_staff"} />}>
              <Route
                path="/backoffice/staff-management/staff/add"
                element={<AddNewStaff />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.staff_management.staff_update"} />}>
              <Route
                path="/backoffice/staff-management/staff/update/:id"
                element={<UpdateStaff />}
              />
            </Route>

            <Route
              path="/"
              element={<Permission keyName={"back_office.staff_management.staff_details"} />}
            >
              <Route
                path="/backoffice/staff-management/staff/profile/:id"
                element={<StaffProfile />}
              />
            </Route>

            {/* role access */}
            <Route
              path="/"
              element={<Permission keyName={"back_office.staff_management.role_access"} />}
            >
              <Route
                path="/backoffice/staff-management/role-access"
                element={<RoleAccess />}
              />
            </Route>

            {/* payroll */}
            <Route
              path="/"
              element={<Permission keyName={["back_office.staff_management.staff_payroll", "back_office.staff_management.staff_attendance"]} />}
            >
              <Route
                path="/backoffice/staff-management/payroll"
                element={<Payroll />}
              />

              <Route
                path="/backoffice/staff-management/payroll/details"
                element={<PayrollDetails />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.staff_management.shift_schedule"} />}>

              <Route
                path="/backoffice/staff-management/shift-schedule"
                element={<ShiftSchedule />}
              />
            </Route>
            {/* staff Report */}

            <Route
              path="/"
              element={<Permission keyName={"back_office.staff_management.staff_reports"} />}
            >
              <Route
                path="/backoffice/staff-management/staff-reports"
                element={<StaffReports />}
              />

              <Route
                path="/backoffice/staff-management/staff-reports/staff-details/:id"
                element={<SingleStaffDetails />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.staff_management.holidays"} />}>
              <Route
                path="/backoffice/staff-management/holidays"
                element={<Holidays />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.staff_management.leave_settings"} />}>
              <Route
                path="/backoffice/staff-management/leaves-settings"
                element={<LeavesSettings />}
              />
            </Route>

            <Route
              path="/"
              element={<Permission keyName={["back_office.staff_management.calender", "back_office.staff_management.roadmap"]} />}
            >
              <Route
                path="/backoffice/staff-management/time-sheet"
                element={<TimeSheet />}
              />
              <Route
                path="/backoffice/staff-management/time-sheet-report/:date"
                element={<TimeSheetReport />}
              />
              <Route
                path="/backoffice/staff-management/time-sheet-schedule"
                element={<TimeSheetSchedule />}
              />
              <Route
                path="/backoffice/staff-management/time-sheet-schedule/:id"
                element={<TimeSheetSchedule />}
              />
            </Route>
            {/* customer */}
            <Route path="/" element={<Permission keyName={["back_office.customer.customer_list"]} />} >
              <Route path="/backoffice/customer" element={<Customer />} />
            </Route>
            <Route path="/" element={<Permission keyName={["back_office.customer.view_details"]} />} >
              <Route
                path="/backoffice/customer/customer/:id"
                element={<CustomerDetails />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.notification.general_notification"} />}>
              <Route
                path="/backoffice/notification"
                element={<AllNotification />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.notification.online_notificaion"} />}>
              <Route
                path="/backoffice/online-notification"
                element={<AllOnlineNotification />}
              />
            </Route>
            {/* menu management */}

            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_drinks"} />}>
              <Route path="/backoffice/menu/drinks" element={<Drinks />} />
            </Route>
            <Route path="/" element={<Permission keyName={["back_office.menu_management.create_drinks", 'back_office.menu_management.update_drinks']} />}>
              <Route
                path="/backoffice/menu/drinks/:type"
                element={<CreateDrinks />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_pizza"} />}>
              <Route path="/backoffice/menu/pizza" element={<Pizza />} />
            </Route>
            <Route path="/" element={<Permission keyName={["back_office.menu_management.create_pizza", 'back_office.menu_management.update_pizza']} />}>
              <Route
                path="/backoffice/menu/pizza/:type"
                element={<CreatePizza />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_tea_coffee"} />}>
              <Route path="/backoffice/menu/tea-coffee" element={<TeaCoffee />} />
            </Route>
            <Route path="/" element={<Permission keyName={["back_office.menu_management.create_tea_coffee", 'back_office.menu_management.update_tea_coffee']} />}>
              <Route
                path="/backoffice/menu/tea-coffee/:type"
                element={<CreateTeaCoffe />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_burger"} />}>
              <Route path="/backoffice/menu/burger" element={<Burger />} />
            </Route>
            <Route path="/" element={<Permission keyName={["back_office.menu_management.create_burger", 'back_office.menu_management.update_burger']} />}>
              <Route
                path="/backoffice/menu/burger/:type"
                element={<CreateBurger />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_kebab"} />}>
              <Route path="/backoffice/menu/kebab" element={<Kabab />} />
            </Route>
            <Route path="/" element={<Permission keyName={["back_office.menu_management.create_kebab", 'back_office.menu_management.update_kebab']} />}>
              <Route
                path="/backoffice/menu/kebab/:type"
                element={<CreateKabab />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_dessert"} />}>
              <Route path="/backoffice/menu/dessert" element={<Dessert />} />
            </Route>
            <Route path="/" element={<Permission keyName={["back_office.menu_management.create_dessert", 'back_office.menu_management.update_dessert']} />}>
              <Route
                path="/backoffice/menu/dessert/:type"
                element={<CreateDessert />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_fish_chips"} />}>
              <Route
                path="/backoffice/menu/fish-chips"
                element={<FishAndChips />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={["back_office.menu_management.create_fish_chips", 'back_office.menu_management.update_fish_chips']} />}>
              <Route
                path="/backoffice/menu/fish-chips/:type"
                element={<CreateFishAndChips />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_standard_foods"} />}>
              <Route
                path="/backoffice/menu/standard-foods"
                element={<StandardFood />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={["back_office.menu_management.create_standard_foods", 'back_office.menu_management.update_standard_foods']} />}>
              <Route
                path="/backoffice/menu/standard-foods/:type"
                element={<CreateStandardFoods />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_combo_meal"} />}>
              <Route path="/backoffice/menu/combo-meal" element={<ComboMeal />} />
            </Route>
            <Route path="/" element={<Permission keyName={["back_office.menu_management.create_combo_meal", "back_office.menu_management.update_combo_meal"]} />}>
              <Route
                path="/backoffice/menu/combo-meal/:type"
                element={<CreateComboMeal />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_course"} />}>
              <Route path="/backoffice/menu/course" element={<Course />} />
            </Route>
            <Route path="/" element={<Permission keyName={['back_office.menu_management.create_course', 'back_office.menu_management.update_course']} />}>
              <Route
                path="/backoffice/menu/course/:type"
                element={<CreateCourse />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_mix_and_match"} />}>
              <Route path="/backoffice/menu/mix-and-match" element={<MixAndMatch />} />
            </Route>
            <Route path="/" element={<Permission keyName={['back_office.menu_management.create_mix_and_match', 'back_office.menu_management.update_mix_and_match']} />}>
              <Route
                path="/backoffice/menu/mix-and-match/:type"
                element={<CreateMixAndMatch />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.menu_management.overview"} />}>
              <Route path="/backoffice/menu/create-your-own-general" element={<CreateYourOwnGeneral />} />
            </Route>
            <Route path="/" element={<Permission keyName={"back_office.menu_management.overview"} />}>
              <Route
                path="/backoffice/menu/create-your-own-general/:type"
                element={<CreateCreateYourOwnGeneral />}
              />
            </Route>

            {/* essential drink */}
            <Route
              path="/backoffice/menu/essentail-menu/drinks/:id"
              element={<EssentialDrink />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/add-category"
              element={<EssentialAddNewCtg />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update"
              element={<EssentialUpdateCtg />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/add-brand"
              element={<EssentialAddNewBrand />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update-brand"
              element={<EssentialUpdateBrand />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/add-ingredients"
              element={<EssentialAddNewIngredients />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update-ingredients"
              element={<EssentialUpdateIngredients />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/add-addons"
              element={<EssentialAddNewAddons />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update-addons"
              element={<EssentialUpdateAddons />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/add-allergen"
              element={<EssentialAddNewAllergen />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update-allergen"
              element={<EssentialUpdateAllergen />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/add-modifiers"
              element={<AddNewModifiers />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update-modifiers"
              element={<UpdateModifiers />}
            />
            {/* essentail tea and coffee */}
            <Route
              path="/backoffice/menu/essentail-menu/tea-coffee/:id"
              element={<EssentialTeaCoffee />}
            />
            {/* essentail burger */}
            <Route
              path="/backoffice/menu/essentail-menu/burger/:id"
              element={<EssentialBurger />}
            />

            <Route
              path="/backoffice/menu/essentail-menu/:id/add-salad"
              element={<EssentialBurgerSaladAdd />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update-salad"
              element={<EssentialBurgerSaladUpdate />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/add-sauce"
              element={<EssentialBurgerSauceAdd />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update-sauce"
              element={<EssentialBurgerSauceUpdate />}
            />
            {/* essentail kebab */}
            <Route
              path="/backoffice/menu/essentail-menu/kebab/:id"
              element={<EssentialKebab />}
            />

            {/* essentail fish chips */}
            <Route
              path="/backoffice/menu/essentail-menu/fish-chips/:id"
              element={<EssentialFishChips />}
            />
            {/* essentail dessert */}
            <Route
              path="/backoffice/menu/essentail-menu/dessert/:id"
              element={<EssentialDessert />}
            />
            {/* essentail standard foods */}
            <Route
              path="/backoffice/menu/essentail-menu/standard-foods/:id"
              element={<EssentialStandardFoods />}
            />
            {/* essential combo meal */}
            <Route
              path="/backoffice/menu/essentail-menu/combo-meal/:id"
              element={<EssentialComboMeal />}
            />
            {/* essential Special menu */}
            <Route
              path="/backoffice/menu/essentail-menu/special-menu/:id"
              element={<EssentialSpecialMenu />}
            />
            {/* essentail pizza */}
            <Route
              path="/backoffice/menu/essentail-menu/pizza/:id"
              element={<EssentialPizza />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/add-base"
              element={<EssentialPizzaAddNewBase />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update-base"
              element={<EssentialPizzaUpdateBase />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/add-crust"
              element={<EssentialPizzaAddNewCrust />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update-crust"
              element={<EssentialPizzaUpdateCrust />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/add-troppings"
              element={<EssentialPizzaAddNewTroppings />}
            />
            <Route
              path="/backoffice/menu/essentail-menu/:id/:item_id/update-tropping"
              element={<EssentialPizzaUpdateTroppings />}
            />
            {/* special menu */}
            <Route path="/" element={<Permission keyName={"back_office.menu_management.list_special_menu"} />}>
              <Route
                path="/backoffice/menu/special-menu/dish-the-day"
                element={<SpecialMenu />}
              />
              <Route
                path="/backoffice/menu/special-menu/dish-the-day/:type"
                element={<CreateDishOfDay />}
              />
              <Route
                path="/backoffice/menu/special-menu/sunday-roast"
                element={<SundayRoast />}
              />
              <Route
                path="/backoffice/menu/special-menu/sunday-roast/:type"
                element={<CreateSundayRoast />}
              />
              <Route
                path="/backoffice/menu/special-menu/banquet-night"
                element={<BanquetNight />}
              />
              <Route
                path="/backoffice/menu/special-menu/banquet-night/:type"
                element={<CreateBanquetNight />}
              />
              <Route
                path="/backoffice/menu/special-menu/buffet"
                element={<Buffet />}
              />
              <Route
                path="/backoffice/menu/special-menu/buffet/:type"
                element={<CreateBuffet />}
              />
              <Route
                path="/backoffice/menu/special-menu/christmas-lunch"
                element={<Christmas />}
              />
              <Route
                path="/backoffice/menu/special-menu/christmas-lunch/:type"
                element={<CreateChristmas />}
              />
              <Route
                path="/backoffice/menu/special-menu/party-platter-sample"
                element={<Party />}
              />
              <Route
                path="/backoffice/menu/special-menu/party-platter-sample/:type"
                element={<CreateParty />}
              />
            </Route>

            {/* online ordering start */}
            <Route path="/online-ordering" element={<OnlineOrdering />} />
            <Route
              path="/onlineordering/website-ordering/order-request"
              element={<OrderRequest />}
            />
            <Route
              path="/onlineordering/website-ordering/order-request/:id"
              element={<SingleOrderRequest />}
            />
            <Route
              path="/onlineordering/website-ordering/order-status"
              element={<OrderStatus />}
            />
            <Route
              path="/onlineordering/website-ordering/order-status/:id"
              element={<SingleOrderStatus />}
            />

            <Route path="/" element={<Permission keyName={"online_ordering.website_order.available_item"} />}>
              <Route
                path="/onlineordering/website-ordering/available-item"
                element={<WebsiteOrderingAvailableItems />}
              />
            </Route>

            <Route
              path="/onlineordering/website-ordering/invoice-statement"
              element={<InvoiceStatementPage />}
            />
            <Route
              path="/onlineordering/website-ordering/invoice-statement/:invoice_id/*"
              element={<InvoiceStatementByDatePage />}
            />

            {/* <Route
              path="/onlineordering/qr-code-ordering/qr-order-request"
              element={<QrOrderRequest />}
            />
            <Route
              path="/onlineordering/qr-code-ordering/qr-order-request/:id"
              element={<SingleQrOrderRequest />}
            />
            <Route
              path="/onlineordering/qr-code-ordering/qr-order-status"
              element={<QrOrderStatus />}
            />
            <Route
              path="/onlineordering/qr-code-ordering/qr-order-status/:id"
              element={<SingleQrOrderStatus />}
            />
            <Route
              path="/onlineordering/qr-code-ordering/qr-available-item"
              element={<QrAvailableItems />}
            />
            <Route
              path="/onlineordering/qr-code-ordering/qr-code-generate"
              element={<QrCodeGenerate />}
            /> */}

            <Route
              path="/onlineordering/online-order-history"
              element={<OnlineOrderHistory />}
            />

            {/* <Route
              path="/onlineordering/settings/website-settings"
              element={<WebsiteSettings />}
            />
            <Route
              path="/onlineordering/settings/notice"
              element={<Notice />}
            />
            <Route
              path="/onlineordering/settings/notice/:type"
              element={<CreateNotice />}
            />
            <Route
              path="/onlineordering/settings/temporary-disable"
              element={<TemporaryDisable />}
            />
            <Route
              path="/onlineordering/settings/order-acceptability"
              element={<OrderAcceptability />}
            />
            <Route
              path="/onlineordering/settings/till-order-access"
              element={<TillOrderAccess />}
            />
            <Route
              path="/onlineordering/settings/online-order-settings"
              element={<OnlineOrderSettings />}
            /> */}
            {/* online ordering end */}

            {/* reservation start */}
            <Route path="/" element={<Permission keyName={"reservation.reservation_list.reservation_list"} />}>
              <Route path="/reservation" element={<ReservationList />} />
            </Route>
            <Route path="/" element={<Permission keyName={"reservation.reservation_request.reservation_request_list"} />}>
              <Route
                path="/reservation/reservation-request-list"
                element={<ReservationRequest />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"reservation.reservation_list.create_reservation"} />}>
              <Route
                path="/reservation/reservation-request/:type"
                element={<AddReservation />}
              />
            </Route>
            <Route
              path="/reservation/details/:id"
              element={<ReservationDetails />}
            />
            <Route
              path="/reservation/rq-details/:id"
              element={<ReservationRqDetails />}
            />
            <Route path="/reservation/calling" element={<CallingUnknown />} />

            <Route path="/backoffice/support-help" element={<SupportHelp />} />
            {/* <Route path="/back-office" element={<Overview/>} /> */}
            {/* <Route path="/back-office/overview" element={<Overview/>} /> */}
            {/* <Route path="/back-office/staff" element={<Staff/>} /> */}
            {/* <Route path="/back-office/staff/add" element={<AddStaff/>} /> */}
            {/* <Route path="/back-office/staff/edit/:id" element={<EditStaff/>} /> */}
            {/* <Route path="/back-office/all-staff" element={<AllStaff/>} /> */}

            {/* </Route> */}

            <Route path="/" element={
              <Permission keyName={"cbd.cbd.cbd"} />
            }>
              <Route path="/cbd/all-customer" element={<CBD />} />
            </Route>
            <Route path="/" element={
              <Permission keyName={"cbd.cbd.view_all_orders"} />
            }>
              <Route
                path="/cbd/single-customer-details/:id"
                element={<SingleCustomerDetails />}
              />
            </Route>

            {/* 
          <Route path="/" element={<Permission keyName={"add-staff"} />}>
            <Route
              path="/backoffice/staff-management/staff/add"
              element={<AddNewStaff />}
            />
          </Route>

          <Route path="/" element={<Permission keyName={"edit-staff"} />}>
            <Route
              path="/backoffice/staff-management/staff/update/:id"
              element={<UpdateStaff />}
            />
          </Route>

          <Route
            path="/"
            element={<Permission keyName={"view-staff-details"} />}
          >
            <Route
              path="/backoffice/staff-management/staff/profile/:id"
              element={<StaffProfile />}
            />
          </Route>

          {/ * role access * /}
          <Route
            path="/"
            element={<Permission keyName={"update-staff-permission"} />}
          >
            <Route
              path="/backoffice/staff-management/role-access"
              element={<RoleAccess />}
            />
          </Route>

          {/ * payroll * /}
          <Route
            path="/"
            element={<Permission keyName={"staff-payroll-list"} />}
          >
            <Route
              path="/backoffice/staff-management/payroll"
              element={<Payroll />}
            />

            <Route
              path="/backoffice/staff-management/payroll/details"
              element={<PayrollDetails />}
            />

            <Route
              path="/backoffice/staff-management/shift-schedule"
              element={<ShiftSchedule />}
            />
          </Route>

          {/ * staff Report * /}

          <Route
            path="/"
            element={<Permission keyName={"staff-attendance-report"} />}
          >
            <Route
              path="/backoffice/staff-management/staff-reports"
              element={<StaffReports />}
            />

            <Route
              path="/backoffice/staff-management/staff-reports/staff-details/:id"
              element={<SingleStaffDetails />}
            />
          </Route>

          <Route path="/" element={<Permission keyName={"holidays"} />}>
            <Route
              path="/backoffice/staff-management/holidays"
              element={<Holidays />}
            />
          </Route>

          <Route path="/" element={<Permission keyName={"staff-leave"} />}>
            <Route
              path="/backoffice/staff-management/leaves-settings"
              element={<LeavesSettings />}
            />
          </Route>

          <Route path="/" element={<Permission keyName={"staff-time-sheet"} />}>
            <Route
              path="/backoffice/staff-management/time-sheet"
              element={<TimeSheet />}
            />
            <Route
              path="/backoffice/staff-management/time-sheet-report/:date"
              element={<TimeSheetReport />}
            />
            <Route
              path="/backoffice/staff-management/time-sheet-schedule"
              element={<TimeSheetSchedule />}
            />
            <Route
              path="/backoffice/staff-management/time-sheet-schedule/:id"
              element={<TimeSheetSchedule />}
            />
          </Route>

          <Route
            path="/backoffice/notification"
            element={<AllNotification />}
          />

          {/ * menu management * /}
          <Route path="/backoffice/menu/drinks" element={<Drinks />} />
          <Route
            path="/backoffice/menu/drinks/:type"
            element={<CreateDrinks />}
          />
          <Route path="/backoffice/menu/pizza" element={<Pizza />} />
          <Route
            path="/backoffice/menu/pizza/:type"
            element={<CreatePizza />}
          />
          <Route path="/backoffice/menu/tea-coffee" element={<TeaCoffee />} />
          <Route
            path="/backoffice/menu/tea-coffee/:type"
            element={<CreateTeaCoffe />}
          />
          <Route path="/backoffice/menu/burger" element={<Burger />} />
          <Route
            path="/backoffice/menu/burger/:type"
            element={<CreateBurger />}
          />
          <Route path="/backoffice/menu/kebab" element={<Kabab />} />
          <Route
            path="/backoffice/menu/kebab/:type"
            element={<CreateKabab />}
          />
          <Route path="/backoffice/menu/dessert" element={<Dessert />} />
          <Route
            path="/backoffice/menu/dessert/:type"
            element={<CreateDessert />}
          />
          <Route
            path="/backoffice/menu/fish-chips"
            element={<FishAndChips />}
          />
          <Route
            path="/backoffice/menu/fish-chips/:type"
            element={<CreateFishAndChips />}
          />
          <Route
            path="/backoffice/menu/standard-foods"
            element={<StandardFood />}
          />
          <Route
            path="/backoffice/menu/standard-foods/:type"
            element={<CreateStandardFoods />}
          />
          <Route path="/backoffice/menu/combo-meal" element={<ComboMeal />} />
          <Route
            path="/backoffice/menu/combo-meal/:type"
            element={<CreateComboMeal />}
          />

          <Route path="/backoffice/menu/course" element={<Course />} />
          <Route
            path="/backoffice/menu/course/:type"
            element={<CreateCourse />}
          />

          <Route path="/backoffice/menu/mix-and-match" element={<MixAndMatch />} />
          <Route
            path="/backoffice/menu/mix-and-match/:type"
            element={<CreateMixAndMatch />}
          />

          <Route
            path="/backoffice/menu/create-your-own-general"
            element={<CreateYourOwnGeneral />}
          />
          <Route
            path="/backoffice/menu/create-your-own-general/:type"
            element={<CreateCreateYourOwnGeneral />}
          />

          {/ * essential drink * /}
          <Route
            path="/backoffice/menu/essentail-menu/drinks/:id"
            element={<EssentialDrink />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/add-category"
            element={<EssentialAddNewCtg />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update"
            element={<EssentialUpdateCtg />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/add-brand"
            element={<EssentialAddNewBrand />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update-brand"
            element={<EssentialUpdateBrand />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/add-ingredients"
            element={<EssentialAddNewIngredients />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update-ingredients"
            element={<EssentialUpdateIngredients />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/add-addons"
            element={<EssentialAddNewAddons />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update-addons"
            element={<EssentialUpdateAddons />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/add-allergen"
            element={<EssentialAddNewAllergen />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update-allergen"
            element={<EssentialUpdateAllergen />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/add-modifiers"
            element={<AddNewModifiers />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update-modifiers"
            element={<UpdateModifiers />}
          />
          {/ * essentail tea and coffee * /}
          <Route
            path="/backoffice/menu/essentail-menu/tea-coffee/:id"
            element={<EssentialTeaCoffee />}
          />
          {/ * essentail burger * /}
          <Route
            path="/backoffice/menu/essentail-menu/burger/:id"
            element={<EssentialBurger />}
          />

          <Route
            path="/backoffice/menu/essentail-menu/:id/add-salad"
            element={<EssentialBurgerSaladAdd />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update-salad"
            element={<EssentialBurgerSaladUpdate />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/add-sauce"
            element={<EssentialBurgerSauceAdd />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update-sauce"
            element={<EssentialBurgerSauceUpdate />}
          />
          {/ * essentail kebab * /}
          <Route
            path="/backoffice/menu/essentail-menu/kebab/:id"
            element={<EssentialKebab />}
          />

          {/ * essentail fish chips * /}
          <Route
            path="/backoffice/menu/essentail-menu/fish-chips/:id"
            element={<EssentialFishChips />}
          />
          {/ * essentail dessert * /}
          <Route
            path="/backoffice/menu/essentail-menu/dessert/:id"
            element={<EssentialDessert />}
          />
          {/ * essentail standard foods * /}
          <Route
            path="/backoffice/menu/essentail-menu/standard-foods/:id"
            element={<EssentialStandardFoods />}
          />
          {/ * essential combo meal * /}
          <Route
            path="/backoffice/menu/essentail-menu/combo-meal/:id"
            element={<EssentialComboMeal />}
          />
          {/ * essential Special menu * /}
          <Route
            path="/backoffice/menu/essentail-menu/special-menu/:id"
            element={<EssentialSpecialMenu />}
          />
          {/ * essentail pizza * /}
          <Route
            path="/backoffice/menu/essentail-menu/pizza/:id"
            element={<EssentialPizza />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/add-base"
            element={<EssentialPizzaAddNewBase />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update-base"
            element={<EssentialPizzaUpdateBase />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/add-crust"
            element={<EssentialPizzaAddNewCrust />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update-crust"
            element={<EssentialPizzaUpdateCrust />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/add-troppings"
            element={<EssentialPizzaAddNewTroppings />}
          />
          <Route
            path="/backoffice/menu/essentail-menu/:id/:item_id/update-tropping"
            element={<EssentialPizzaUpdateTroppings />}
          />
          {/ * special menu * /}
          <Route
            path="/backoffice/menu/special-menu/dish-the-day"
            element={<SpecialMenu />}
          />
          <Route
            path="/backoffice/menu/special-menu/dish-the-day/:type"
            element={<CreateDishOfDay />}
          />
          <Route
            path="/backoffice/menu/special-menu/sunday-roast"
            element={<SundayRoast />}
          />
          <Route
            path="/backoffice/menu/special-menu/sunday-roast/:type"
            element={<CreateSundayRoast />}
          />
          <Route
            path="/backoffice/menu/special-menu/banquet-night"
            element={<BanquetNight />}
          />
          <Route
            path="/backoffice/menu/special-menu/banquet-night/:type"
            element={<CreateBanquetNight />}
          />
          <Route
            path="/backoffice/menu/special-menu/buffet"
            element={<Buffet />}
          />
          <Route
            path="/backoffice/menu/special-menu/buffet/:type"
            element={<CreateBuffet />}
          />
          <Route
            path="/backoffice/menu/special-menu/christmas-lunch"
            element={<Christmas />}
          />
          <Route
            path="/backoffice/menu/special-menu/christmas-lunch/:type"
            element={<CreateChristmas />}
          />
          <Route
            path="/backoffice/menu/special-menu/party-platter-sample"
            element={<Party />}
          />
          <Route
            path="/backoffice/menu/special-menu/party-platter-sample/:type"
            element={<CreateParty />}
          />

          {/ * online ordering start * /}
          <Route path="/online-ordering" element={<OnlineOrdering />} />
          <Route
            path="/onlineordering/website-ordering/order-request"
            element={<OrderRequest />}
          />
          <Route
            path="/onlineordering/website-ordering/order-request/:id"
            element={<SingleOrderRequest />}
          />
          <Route
            path="/onlineordering/website-ordering/order-status"
            element={<OrderStatus />}
          />
          <Route
            path="/onlineordering/website-ordering/order-status/:id"
            element={<SingleOrderStatus />}
          />

          <Route path="/" element={<Permission keyName={"online_ordering.website_order.available_item"} />}>
            <Route
              path="/onlineordering/website-ordering/available-item"
              element={<WebsiteOrderingAvailableItems />}
            />
          </Route>

*/}
            {/* <Route
            path="/onlineordering/qr-code-ordering/qr-order-request"
            element={<QrOrderRequest />}
          />
          <Route
            path="/onlineordering/qr-code-ordering/qr-order-request/:id"
            element={<SingleQrOrderRequest />}
          />
          <Route
            path="/onlineordering/qr-code-ordering/qr-order-status"
            element={<QrOrderStatus />}
          />
          <Route
            path="/onlineordering/qr-code-ordering/qr-order-status/:id"
            element={<SingleQrOrderStatus />}
          />
          <Route
            path="/onlineordering/qr-code-ordering/qr-available-item"
            element={<QrAvailableItems />}
          />
          <Route
            path="/onlineordering/qr-code-ordering/qr-code-generate"
            element={<QrCodeGenerate />}
          /> */}

            <Route
              path="/onlineordering/qr-code/general"
              element={<GeneralQRCode />}
            />

            {/* 
          <Route
            path="/onlineordering/online-order-history"
            element={<OnlineOrderHistory />}
          />
*/}

            <Route path="/" element={<Permission keyName={"online_ordering.qr_code.smart_qr"} />}>
              <Route
                path="/onlineordering/qr-code/smart-ordering"
                element={<SmartQRCodeOrder />}
              />
              <Route
                path="/onlineordering/qr-code/add-smart-ordering"
                element={<AddSmartQRCodeOrder />}
              />
              <Route
                path="/onlineordering/qr-code/edit-smart-ordering/:id"
                element={<EditSmartQRCodeOrder />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"online_ordering.settings"} />}>
              <Route
                path="/onlineordering/settings/website-settings"
                element={<WebsiteSettings />}
              />
              <Route
                path="/onlineordering/settings/reserve-order-settings"
                element={<ReservationOrderSettings />}
              />

              <Route path="/onlineordering/settings/notice" element={<Notice />} />
              <Route
                path="/onlineordering/settings/notice/:type"
                element={<CreateNotice />}
              />
              <Route
                path="/onlineordering/settings/temporary-disable"
                element={<TemporaryDisable />}
              />
              <Route
                path="/onlineordering/settings/order-acceptability"
                element={<OrderAcceptability />}
              />
              <Route
                path="/onlineordering/settings/till-order-access"
                element={<TillOrderAccess />}
              />
              <Route
                path="/onlineordering/settings/online-order-settings"
                element={<OnlineOrderSettings />}
              />

            </Route>
            {/* online ordering end */}

            {/* 
          {/ * reservation start * /}
          <Route path="/reservation" element={<ReservationList />} />
          <Route
            path="/reservation/reservation-request-list"
            element={<ReservationRequest />}
          />
          <Route
            path="/reservation/reservation-request/:type"
            element={<AddReservation />}
          />
          <Route
            path="/reservation/details/:id"
            element={<ReservationDetails />}
          />
          <Route
            path="/reservation/rq-details/:id"
            element={<ReservationRqDetails />}
          />
          <Route path="/reservation/calling" element={<CallingUnknown />} />

*/}
            {/* Dashboard module */}
            <Route path="/" element={<Permission keyName={"dashboard"} />}>
              <Route path="/dashboard" element={<DashboardMain />} />
            </Route>
            <Route path="/" element={<Permission keyName={"dashboard"} />}>
              <Route path="/dashboard/overview" element={<DashboardOverview />} />
            </Route>
            <Route path="/" element={<Permission keyName={"dashboard.reports.revenue_report"} />}>
              <Route
                path="/dashboard/revenue-reports"
                element={<RevenueReports />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"dashboard.reports.call_log_report"} />}>
              <Route
                path="/dashboard/call-log-reports"
                element={<CallLogReports />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"dashboard.reports.order_report"} />}>
              <Route path="/dashboard/order-reports" element={<OrderReports />} />
            </Route>
            <Route path="/" element={<Permission keyName={"dashboard.reports.reservation_report"} />}>
              <Route
                path="/dashboard/reservation-reports"
                element={<ReservationReports />}
              />
            </Route>

            <Route path="/" element={<Permission keyName={"dashboard.reports.table_report"} />}>
              <Route path="/dashboard/table-reports" element={<TableReports />} />
            </Route>
            <Route path="/" element={<Permission keyName={"dashboard.reports.loyalty_report"} />}>
              <Route
                path="/dashboard/loyalty-reports"
                element={<LoyaltyReports />}
              />
            </Route>
            <Route path="/" element={<Permission keyName={"dashboard.reports.menu_report"} />}>
              <Route path="/dashboard/menu-reports" element={<MenuReports />} />
            </Route>

            <Route path="/" element={<Permission keyName={"dashboard.reports.staff_report"} />}>
              <Route
                path="/dashboard/staff-reports"
                element={<DashboardStaffReport />}
              />
            </Route>


            {/* 
          <Route path="/backoffice/support-help" element={<SupportHelp />} />
          {/ * <Route path="/back-office" element={<Overview/>} /> * /}
          {/ * <Route path="/back-office/overview" element={<Overview/>} /> * /}
          {/ * <Route path="/back-office/staff" element={<Staff/>} /> * /}
          {/ * <Route path="/back-office/staff/add" element={<AddStaff/>} /> * /}
          {/ * <Route path="/back-office/staff/edit/:id" element={<EditStaff/>} /> * /}
          {/ * <Route path="/back-office/all-staff" element={<AllStaff/>} /> * /}

          {/ * </Route> * /}

          <Route path="/cbd/all-customer" element={<CBD />} />
          <Route
            path="/cbd/single-customer-details"
            element={<SingleCustomerDetails />}
          />
*/}
          </Route>

          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/failed" element={<PaymentFailed />} />
          <Route path="/payment/cancelled" element={<PaymentCancelled />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
